import { ILink } from '@app/models/links';

const RELEASE_DATE = 'releaseDate';

export function getReleaseDate(appConstants: ILink[]): Date {
  const releaseDateString = appConstants.find(({ key }) => key === RELEASE_DATE).value;
  const year = parseInt(releaseDateString.slice(-4), 10);
  const month = parseInt(releaseDateString.slice(0, 2), 10) - 1;
  return new Date(year, month);
}

export function getMenuLinks(appConstants: ILink[]): ILink[] {
  return appConstants.filter(({ key }) => key !== RELEASE_DATE);
}
